<div class="game-period-filters">
	<mtg-dropdown
		[formControl]="setControl"
		label="Сет"
		variant="button"
		[errorVisible]="false"
	>
		<mtg-dropdown-item
			*ngFor="let gameSet of sets"
			[value]="gameSet"
		>{{ gameSet }} сет
		</mtg-dropdown-item>
	</mtg-dropdown>

	<mtg-dropdown
		[formControl]="positionControl"
		label="Амплуа"
		variant="button"
		[errorVisible]="false"
	>
		<mtg-dropdown-item
			*ngFor="let value of positions"
			[value]="value"
		>{{ value | localization: positionLocalization }}</mtg-dropdown-item>
	</mtg-dropdown>
	<div class="search">
		<mtg-text-field
			size="sm"
			placeholder="Искать игрока..."
			[formControl]="query"
			trailingIcon="icons-search"
		></mtg-text-field>
	</div>
</div>
<mtg-table>
	<mtg-table-header-row mtgSticky="top" [top]="headerHeight">
		<mtg-table-identity-col>
			<div class="team">
				<div class="logo">
					<a [routerLink]="getTeamRoute(team.id)">
						<img [src]="team.logo.path" *ngIf="team.logo.path" [alt]="team.name"/>
						<div [class]="team.getEmptyLogoClass()" *ngIf="!team.logo.path"></div>
					</a>
				</div>
				<div class="name">
					<a [routerLink]="getTeamRoute(team.id)">{{ team.name }}</a>
				</div>
			</div>
		</mtg-table-identity-col>
		<mtg-table-col>Очки</mtg-table-col>
		<mtg-table-col>Ошибки</mtg-table-col>
		<mtg-table-col-group title="Подача">
			<mtg-table-col>Всего</mtg-table-col>
			<mtg-table-col>Ошибки</mtg-table-col>
			<mtg-table-col>Эйсы</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="Атака">
			<mtg-table-col>Всего</mtg-table-col>
			<mtg-table-col>Ошибки</mtg-table-col>
			<mtg-table-col>Очки</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="Блок">
			<mtg-table-col>Всего</mtg-table-col>
			<mtg-table-col>Ошибки</mtg-table-col>
			<mtg-table-col>Очки</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="Защитные действия" *ngIf="!isLight">
			<mtg-table-col>Всего</mtg-table-col>
			<mtg-table-col>Ошибки</mtg-table-col>
			<mtg-table-col>Отличный прием</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="Прием подачи" *ngIf="!isLight">
			<mtg-table-col>Всего</mtg-table-col>
			<mtg-table-col>Ошибки</mtg-table-col>
			<mtg-table-col>Отличный прием</mtg-table-col>
		</mtg-table-col-group>
	</mtg-table-header-row>
	<mtg-table-row>
		<mtg-table-identity-col>
			<div class="total-title">
				<mtg-svg-icon icon="icons-valleyball"></mtg-svg-icon>
				Всего
			</div>
		</mtg-table-identity-col>
		<mtg-table-col>{{ getTotal('points' ) }}</mtg-table-col>
		<mtg-table-col>{{ getTotal('faults') }}</mtg-table-col>
		<mtg-table-col-group>
			<mtg-table-col>{{ getTotal('serveAces') + getTotal('serveHits') + getTotal('serveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('serveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('serveAces') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getTotal('attackSpikes') + getTotal('attackShots') + getTotal('attackFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('attackFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('attackSpikes') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getTotal('stuffBlocks') + getTotal('blockRebounds') + getTotal('blockFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('blockFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('stuffBlocks') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group *ngIf="!isLight">
			<mtg-table-col>{{ getTotal('excellentReceives') + getTotal('receives') + getTotal('receiveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('receiveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('excellentReceives') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group *ngIf="!isLight">
			<mtg-table-col>{{ getTotal('excellentServeReceives') + getTotal('serveReceives') + getTotal('serveReceiveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('serveReceiveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('excellentServeReceives') }}</mtg-table-col>
		</mtg-table-col-group>
	</mtg-table-row>
	<mtg-table-row *ngFor="let user of filteredUsers; trackBy: identify">
		<mtg-table-identity-col>
			<div class="number">{{ user.gameUserNumber }}</div>
			<div class="photo">
				<a [routerLink]="getUserProfileRoute(user)">
					<img [src]="user.tournamentTeamUser.leaguePlayer.photo.path" *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path">
					<div class="empty-photo" *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">{{ user.tournamentTeamUser.leaguePlayer.initials }}</div>
				</a>
			</div>
			<div class="info">
				<a [routerLink]="getUserProfileRoute(user)">
					<div class="name">{{ user.tournamentTeamUser.leaguePlayer.shortName }}</div>
					<div class="text-muted">{{ user.teamUser.user.volleyballProfile.position | localization: positionLocalization }}</div>
				</a>
			</div>
		</mtg-table-identity-col>
		<mtg-table-col>{{ getUserStatistic(user.id, 'points') }}</mtg-table-col>
		<mtg-table-col>{{ getUserStatistic(user.id, 'faults') }}</mtg-table-col>
		<mtg-table-col-group>
			<mtg-table-col>
				{{ getUserStatistic(user.id, 'serveHits') + getUserStatistic(user.id, 'serveFaults') + getUserStatistic(user.id, 'serveAces') }}
			</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'serveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'serveAces') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>
				{{ getUserStatistic(user.id, 'attackSpikes') + getUserStatistic(user.id, 'attackShots') + getUserStatistic(user.id, 'attackFaults') }}
			</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'attackFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'attackSpikes') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>
				{{ getUserStatistic(user.id, 'stuffBlocks') + getUserStatistic(user.id, 'blockRebounds') + getUserStatistic(user.id, 'blockFaults') }}
			</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'blockFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'stuffBlocks') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group *ngIf="!isLight">
			<mtg-table-col>
				{{ getUserStatistic(user.id, 'excellentReceives') + getUserStatistic(user.id, 'receives') + getUserStatistic(user.id, 'receiveFaults') }}
			</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'receiveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'excellentReceives') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group *ngIf="!isLight">
			<mtg-table-col>
				{{ getUserStatistic(user.id, 'excellentServeReceives') + getUserStatistic(user.id, 'serveReceives') + getUserStatistic(user.id, 'serveReceiveFaults') }}
			</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'serveReceiveFaults') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'excellentServeReceives') }}</mtg-table-col>
		</mtg-table-col-group>
	</mtg-table-row>
</mtg-table>
